import ApiRoutes from "../../../constants/api-routes";
import { hneAdminApi, hneAdminMultiApi } from "../../../service";

export const createNewNews = async (body) =>
  hneAdminApi.post(`${ApiRoutes.CREATE_NEWS}`, body);

export const createNewNewsMulti = async (body) =>
  hneAdminMultiApi.post(`${ApiRoutes.CREATE_NEWS}`, body);

export const addUpdateNews = async (body, news_id) =>
  hneAdminApi.put(`${ApiRoutes.ADD_UPDATE_NEWS}/${news_id}`, body);

export const addNewsComment = async (body, news_id) =>
  hneAdminApi.post(`${ApiRoutes.ADD_NEWS_COMMENT}?news_id=${news_id}`, body);

export const changeCommentLike = async (action, comment_id, news_id) =>
  hneAdminApi.post(
    `${ApiRoutes.CHANGE_NEWS_COMMENT_LIKE}?action=${action}&comment_id=${comment_id}&news_id=${news_id}`
  );

export const updateNewsCommentStatus = async (status, comment_id, news_id) =>
  hneAdminApi.put(
    `${ApiRoutes.UPDATE_COMMENT_STATUS}?status=${status}&comment_id=${comment_id}&news_id=${news_id}`
  );

export const deleteNewsComment = async (comment_id, news_id) =>
  hneAdminApi.delete(
    `${ApiRoutes.DELETE_NEWS_COMMENT}/${comment_id}/${news_id}`
  );

export const updateNews = async (body, news_id) =>
  hneAdminApi.put(`${ApiRoutes.UPDATE_NEWS}/${news_id}`, body);

export const updateNewsMulti = async (body, news_id) =>
  hneAdminMultiApi.put(`${ApiRoutes.UPDATE_NEWS}/${news_id}`, body);

export const getAllNews = async (language) =>
  hneAdminApi.get(`${ApiRoutes.GET_ALL_NEWS}/${language}`);

export const getNewsByPage = async (language, page_count, page_no) =>
  hneAdminApi.get(
    `${ApiRoutes.GET_NEWS_BY_PAGE}/${language}/${page_count}/${page_no}`
  );

export const getNewsByCategory = async (category_id, page_count, page_no) =>
  hneAdminApi.get(
    `${ApiRoutes.GET_NEWS_BY_CATEGORY_BY_PAGE}/${category_id}/${page_count}/${page_no}`
  );

export const getNewsByTag = async (tag_id) =>
  hneAdminApi.get(`${ApiRoutes.GET_NEWS_BY_TAG}/${tag_id}`);

export const getNewsByWidget = async (widget_id) =>
  hneAdminApi.get(`${ApiRoutes.GET_NEWS_BY_WIDGET}/${widget_id}`);

export const getNewsByTopTags = async () =>
  hneAdminApi.get(`${ApiRoutes.GET_NEWS_BY_TOP_TAGS}`);

export const getNewsByCategoryPage = async (
  category_id,
  page_count,
  language,
  news_id
) =>
  hneAdminApi.get(
    `${
      ApiRoutes.GET_NEWS_BY_CATEGORY
    }/${category_id}/${page_count}/${language}?news_id=${news_id || ""}`
  );

export const getSuggestionsNews = async (
  language,
  insight_id,
  news_id,
  noOfNews
) =>
  hneAdminApi.get(
    `${ApiRoutes.GET_SUGGESTIONS_NEWS}/${language}/${insight_id}/${news_id}/${noOfNews}`
  );

export const getNewsBullets = async () =>
  hneAdminApi.get(`${ApiRoutes.GET_NEWS_BULLETS}`);

export const deactivateNews = async (news_id, body) =>
  hneAdminApi.put(`${ApiRoutes.DEACTIVATE_NEWS}/${news_id}`, body);

export const getAllPastNews = async (language, pageNo, pageSize) =>
  hneAdminApi.get(
    `${ApiRoutes.GET_ALL_PAST_NEWS}/${language}/${pageNo}/${pageSize}`
  );

export const getNewsByKeyword = async (body, language) =>
  hneAdminApi.post(
    `${ApiRoutes.GET_NEWS_BY_KEYWORD}?language=${language}`,
    body
  );

export const getNewsKeywords = async (body, language) =>
  hneAdminApi.post(`${ApiRoutes.GET_NEWS_KEYWORDS}?language=${language}`, body);

export const deleteWidgetNews = async (news_id) =>
  hneAdminApi.delete(`${ApiRoutes.DELETE_WIDGET_NEWS}/${news_id}`);
